@if (mortgageCalculationService.showDefaultDisplay()) {
    <ng-container id="defaultMaxMortgage" *ngTemplateOutlet="maxMortgage"></ng-container>
}
@if (mortgageCalculationService.showStickyMobileDisplay()) {
    <div [ngClass]="{ stickyContainer: true, 'ap-padding-3': true }">
        <ng-container *ngTemplateOutlet="maxMortgage"></ng-container>
    </div>
}
@if (mortgageCalculationService.showDesktopDisplay()) {
    <ap-card class="stickyBlock">
        <ng-container *ngTemplateOutlet="maxMortgage"></ng-container>
    </ap-card>
}

<ng-template #maxMortgage>
    @if (mortgageCalculationResponse) {
        @if (apError !== undefined) {
            @if (mortgageCalculationService.showMobileError()) {
                <h2>{{ apError.title }}</h2>
                <div>{{ apError.message }}</div>
            } @else {
                <ap-error [apError]="apError"></ap-error>
            }
        } @else {
            @if (mortgageCalculationResponse.mortgage.expected_mortgage) {
                <max-mortgage
                    [mortgageDetails]="mortgageCalculationResponse?.mortgage.expected_mortgage"
                    [key]="buttonKey.EXPECTED_MORTGAGE"
                    [showMonthlyAmounts]="true"
                    [id]="'expected-mortgage'"
                ></max-mortgage>
                @if (mortgageCalculationService.showDisclaimer()) {
                    <disclaimer [mortgageDetails]="mortgageCalculationResponse?.mortgage.expected_mortgage"></disclaimer>
                }
            } @else {
                <max-mortgage
                    [mortgageDetails]="mortgageCalculationResponse?.mortgage.max_mortgage_by_income"
                    [showMonthlyAmounts]="true"
                    [id]="'max-mortgage-by-income'"
                ></max-mortgage>
                @if (mortgageCalculationService.showDisclaimer()) {
                    <disclaimer [mortgageDetails]="mortgageCalculationResponse?.mortgage.max_mortgage_by_income"></disclaimer>
                }
            }
            @if (mortgageCalculationService.showAccordion()) {
                <div class="ap-margin-top-3">
                    @if (showAssetDeficiency()) {
                        <asset-deficiency [assetDeficiency]="mortgageCalculationResponse?.mortgage.asset?.amount"></asset-deficiency>
                    } @else {
                        <max-mortgage
                            [mortgageDetails]="mortgageCalculationResponse?.mortgage.max_mortgage_by_income"
                            [showMonthlyAmounts]="false"
                            [id]="'max-mortgage-by-income'"
                        ></max-mortgage>
                    }
                    @if (mortgageCalculationService.showDisclaimer()) {
                        <p id="disclaimerAppointmentText" class="ap-help-text">
                            {{ 'mortgage-calculation.disclaimer-appointment.text' | apContent }}
                        </p>
                    }
                </div>
                @if (showPdfDownload()) {
                    <ap-icon-button-link iconName="download" (click)="storeService.download()">{{
                        'mortgage-calculation.download-result.title' | apContent
                    }}</ap-icon-button-link>

                    <div class="ap-margin-top-1 ap-text-align-center">
                        <ap-spinner
                            [visuallyHiddenLabel]="true"
                            loadingText="{{ 'mortgage-calculation-download.spinner.loading' | apContent }}"
                            readyText="{{ 'mortgage-calculation-download.spinner.ready' | apContent }}"
                            [state]="storeService.getLoadingStateDownload() | async"
                            [size]="'small'"
                            [icon]="true"
                        ></ap-spinner>
                    </div>
                }
            }
        }

        @if (mortgageCalculationService.showAppointmentButton(apError)) {
            <div class="ap-margin-top-3">
                <ap-appointment-button></ap-appointment-button>
            </div>
        }
    }
</ng-template>
